<template>
  <div
    :class="[
      $style.PFChatMessage,
      {
        [$style.PFChatMessageMy]: my
      }
    ]"
  >
    <span :class="$style.PFChatMessageText">
      <slot />
    </span>
    <span :class="$style.PFChatMessageTime">
      {{ setTime() }}
    </span>
    <div :class="$style.PFChatMessageShape">
      <svg
        :class="$style.PFChatMessageShapeIcon"
        width="10"
        height="14"
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00147 0C8.50147 5 6.65619 8.06653 1.67373 10.0147L1.33788 10.1425C0.819874 10.334 0.555199 10.9091 0.746696 11.4271C0.818507 11.6214 0.948854 11.7885 1.11974 11.9055C2.88026 13.1108 5.72057 13.8089 9.64062 14C9.00146 10.5 9.00153 6.5 9.00147 0Z" fill="currentColor" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    my: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setTime () {
      return new Date().toLocaleTimeString('en-US', { hour12: false }).substring(0, 5)
    }
  }
}
</script>

<style module lang="scss">
.PFChatMessage {
  all: unset;
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  padding: calc(14px * var(--pf-chat-scale)) calc(14px * var(--pf-chat-scale)) calc(27px * var(--pf-chat-scale)) calc(14px * var(--pf-chat-scale));
  background: #fafafa;
  border-radius: calc(8px * var(--pf-chat-scale));
  margin-left: calc(4px * var(--pf-chat-scale));
  max-width: calc(100% - calc(25px * var(--pf-chat-scale)));
  min-width: calc(80px * var(--pf-chat-scale));

  &.PFChatMessageMy {
    margin-left: 0;
  }
}

.PFChatMessageText {
  all: unset;
  display: inline;
  word-wrap: anywhere !important;
  max-width: 100%;
  color: #000;
  font-style: normal;
  font-weight: 400;
  font-size: calc(16px * var(--pf-chat-scale));
  line-height: calc(21px * var(--pf-chat-scale));
  font-family: 'Roboto', sans-serif !important;
}

.PFChatMessageTime {
  all: unset;
  position: absolute;
  bottom: calc(10px * var(--pf-chat-scale));
  right: calc(14px * var(--pf-chat-scale));
  display: inline;
  word-wrap: anywhere !important;
  max-width: 100%;
  color: rgba(0, 0, 0, 0.25);
  font-style: normal;
  font-weight: 400;
  font-size: calc(11px * var(--pf-chat-scale));
  line-height: calc(13px * var(--pf-chat-scale));
  font-family: 'Roboto', sans-serif !important;
}

.PFChatMessageShape {
  all: unset;
  position: absolute;
  z-index: 1;
  bottom: calc(6px * var(--pf-chat-scale));
  right: calc(100% - calc(2px * var(--pf-chat-scale)));
}

.PFChatMessageMy {
  .PFChatMessageShape {
    right: auto;
    left: calc(100% - calc(2px * var(--pf-chat-scale)));
    transform: scaleX(-1);
  }
}

.PFChatMessageShapeIcon {
  all: unset;
  display: flex;
  color: #fafafa;
  width: calc(10px * var(--pf-chat-scale));
  height: calc(14px * var(--pf-chat-scale));
}
</style>
